// src/utils/loadingManager.js
import * as THREE from "three";

let manager = null;
const subs = new Set();
let byCount = 0;
let byBytes = 0;
let totalFiles = 0;
let loadedFiles = 0;

function emitProgress() {
  const raw = byCount * 0.3 + byBytes * 0.7;
  // ako želiš 0–99 bez decimala:
  const pct = Math.min(99, Math.round(raw));   // ili Math.floor(raw)

  subs.forEach(fn => fn({ type: "progress", progress: pct }));
}


export function getLoadingManager() {
  if (manager) return manager;
  manager = new THREE.LoadingManager();

  manager.onStart = (url, itemsLoaded, itemsTotal) => {
    byCount = 0; 
    byBytes = 0;
    totalFiles = itemsTotal;
    loadedFiles = 0;
    subs.forEach(fn => fn({ type: "start", progress: 0 }));
  };

  manager.onProgress = (url, itemsLoaded, itemsTotal) => {
    loadedFiles = itemsLoaded;
    totalFiles = itemsTotal;
    byCount = itemsTotal ? Math.round((itemsLoaded / itemsTotal) * 100) : Math.min(95, byCount + 5);
    emitProgress();
  };

  manager.onLoad = () => {
    // Don't immediately jump to 100%, wait for final processing
    byCount = 100;
    byBytes = 100;
    emitProgress();
    
    // Small delay to ensure everything is really loaded
    setTimeout(() => {
      subs.forEach(fn => fn({ type: "done", progress: 100 }));
    }, 100);
  };

  manager.onError = (url) => {
    console.error("Error loading:", url);
  };

  return manager;
}

export function subscribeLoading(cb) {
  subs.add(cb);
  cb({ type: "progress", progress: Math.max(byCount, byBytes) });
  return () => subs.delete(cb);
}

export function reportXHRProgress(loaded, total) {
  if (!total) return;
  byBytes = Math.round((loaded / total) * 100 * 0.95);
  emitProgress();
}

export function hideAfterFirstFrame(renderer, scene, camera, setLoading) {
  requestAnimationFrame(() => {
    renderer.render(scene, camera);
    requestAnimationFrame(() => setLoading(false));
  });
}